// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinner-wrapper[data-v-7123a9a1]{height:0;padding-bottom:100%;width:100%;margin-left:5%}.spinner-wrapper .spinner[data-v-7123a9a1]{position:relative;padding:0;height:0;padding-bottom:100%;width:100%}.spinner-wrapper .spinner img[data-v-7123a9a1]{width:90%;position:absolute;left:0}", ""]);
// Exports
module.exports = exports;
